import { defineMessages } from 'react-intl';

export default defineMessages({
  markets: 'Markets',
  dashboard: 'My dashboard',
  deposit: 'Deposit',
  borrow: 'Borrow',
  swap: 'Swap',
  stake: 'Stake',
  governance: 'Governance',
});
